import { Container } from '@mui/material';
import React, { FC } from 'react';
import IframeComponent from 'src/components/ui-component/i-frame/IframeComponent ';
import ScrollToTop from '../../../components/layout/ScrollToTop';

const BarrierefreiheitMelden: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />

			<Container>
				<IframeComponent src='https://datenschutzgenerator.hessen-agentur.de/projektBarrierefreiForm.cfm?pid=28' />
			</Container>
		</>
	);
};
export default BarrierefreiheitMelden;
